export const locationAddressData = [{
    location: 'Frankfurt', info: [{
        venueName: 'neosfer GmbH',
        addressLine1: 'Eschersheimer Landstraße 6',
        addressLine2: '60322 Frankfurt am Main',
        gmapsLink: 'https://www.google.com/maps/place/Main+Incubator+GmbH/@50.1188996,8.6789054,17z/data=!3m1!4b1!4m6!3m5!1s0x47bd0966f3b83577:0x829f1a80b82bd805!8m2!3d50.1188996!4d8.6789054!16s%2Fg%2F1pzpn9gbb?entry=ttu',
    }],
}, {
    location: 'Prague', info: [{
        extraInfo: "Registration & opening:",
        venueName: 'National Library of Technology',
        addressLine1: 'Technická 6',
        addressLine2: '160 00 Praha 6',
        gmapsLink: 'https://www.google.de/maps/place/National+Library+of+Technology/@50.1048309,14.3893932,17.5z/data=!4m15!1m8!3m7!1s0x470b953a13ad2557:0x7c8756d4843591b4!2sTh%C3%A1kurova+9,+160+00+Praha+6,+Czechia!3b1!8m2!3d50.1051548!4d14.3897184!16s%2Fg%2F11bw3zhx6g!3m5!1s0x470b94e8b61a7d13:0x917af83b84a0902!8m2!3d50.1038974!4d14.3906537!16s%2Fm%2F0h7nyb4?entry=ttu',
    }, {
        extraInfo: "Main Event:",
        venueName: 'Fakulta informačních technologií ČVUT',
        addressLine1: 'Thákurova 9',
        addressLine2: '160 00 Praha 6',
        gmapsLink: 'https://www.google.com/maps/place/Fakulta+informa%C4%8Dn%C3%ADch+technologi%C3%AD+%C4%8CVUT+v+Praze/@50.1050046,14.3868575,17z/data=!3m1!4b1!4m6!3m5!1s0x470b953a124e3999:0x8eb9c6f77808fa69!8m2!3d50.1050012!4d14.3894378!16s%2Fg%2F121v23c9?entry=ttu',
    }],
}, {
    location: 'Łódź', info: [{
        venueName: 'Textorial Park',
        addressLine1: 'Fabryczna 17',
        addressLine2: '90-344 Łódź',
        gmapsLink: 'https://www.google.com/maps/place/Textorial+Park/@51.7571777,19.4756801,14z/data=!4m6!3m5!1s0x471a34cbc8437fa1:0x562f4ccbbc07bc84!8m2!3d51.7563697!4d19.479344!16s%2Fg%2F12xq9lh_r?entry=ttu',
    }],
}, {
    location: 'Sofia', info: [{
        venueName: 'Joy Station',
        addressLine1: 'ulitsa "Akademik Stefan Mladenov"',
        addressLine2: '1700 Studentski grad, Sofia',
        gmapsLink: 'https://www.google.com/maps/place/Joy+Station/@42.654456,23.3444509,17z/data=!3m1!4b1!4m6!3m5!1s0x40aa8424b4bfb069:0x3885fc613da55422!8m2!3d42.6544521!4d23.3470312!16s%2Fg%2F11bbrgnvy9?entry=ttu',
    }],
},];
